<template>
  <DatatableReportV3
    id="linked-calls-table"
    ref="linked-calls_datatable"
    title="Linked Calls"
    class="no-cursor"
    :config="config"
    :source="source"
    :filters="filters"
    :map-records="applyFilter"
    subpage
    flat
    no-download
  >
    <template #actions>
      <slot name="actions"></slot>
    </template>
  </DatatableReportV3>
</template>

<script>
import { getPathValueAt } from "@/lib/url.js";

import SecondsLabel from "@/components/SecondsLabel.vue";
import CallModalLink from "@/CallComponents/CallModalLink.vue";
import UnlinkCallIcon from "@/CallComponents/UnlinkCallIcon.vue";
import CONSTANTS from "@/Constants.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ""
    }
  },
  computed: {
    config() {
      const entity = getPathValueAt(0); // jobs|customers
      return {
        vueComponents: [
          {
            rootId: "unlink-call-link-vue",
            component: UnlinkCallIcon,
            options: {
              store
            }
          },
          {
            rootId: "seconds-label-vue",
            component: SecondsLabel
          },
          {
            rootId: "call-modal-link-vue",
            component: CallModalLink,
            options: {
              store
            }
          }
        ],
        order: [[4, "desc"]],
        columns: [
          {
            data: "call_id",
            title: "Call ID",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.calls
          },
          {
            data: "call_status",
            title: "Status",
            orderData: 2,
            searchable: false
          },
          { data: "call_status_alpha", visible: false, searchable: false },
          {
            data: "linked_id",
            title: "Job #",
            orderable: true,
            visible: entity === "customers"
          },
          {
            data: "start_time",
            title: "Start Time",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.days,
            className: "whitespace-nowrap-important"
          },
          { data: "answered", title: "Answered", searchable: false },
          {
            data: "duration",
            title: "Duration",
            className: "text-right",
            searchable: false
          },
          {
            data: "ended_at",
            title: "End Time",
            className: "whitespace-nowrap-important"
          },
          {
            data: "claimed_by",
            title: "Assigned To",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.assignees
          },
          { data: "caller_id", title: "Caller ID" },
          {
            data: "phone",
            title: "Phone #"
          },
          {
            data: "call_source",
            title: "Call Source",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.sources
          },
          {
            data: "unlink_action",
            title: "Unlink",
            orderable: false,
            className: "text-center",
            searchable: false
          }
        ]
      };
    }
  },
  methods: {
    applyFilter(record) {
      // Find customer/job id
      // apply that key to the record
      const entity = getPathValueAt(0); // jobs|customers
      const id = getPathValueAt(1); // id

      // customer_id makes this datatable only show linked calls to the customer their jobs
      // job_id makes this datatable only show linked calls for a job
      // linkable type and id are set to create the link/unlink URLs
      if (entity === "customers") {
        record.customer_id = id;

        record.linkable_type = "User";
        record.linkable_id = id;
      }
      if (entity === "jobs") {
        record.job_id = id;
        record.linkable_type = "Job";
        record.linkable_id = id;
      }
      return record;
    }
  }
};
</script>

<style lang="scss" scoped></style>
